import {
   ApiEditarJustificativa,
   ApiObterDetalhesJustificativa,
   ApiObterGrupoUsuario,
   ApiObterJustificativa,
   ApiObterOcorrenciaTipo,
   ApiRegistrarJustificativa
} from '@/api'
import {
   EDITAR_JUSTIFICATIVA,
   INCLUIR_JUSTIFICATIVA,
   OBTER_DESCRICAO,
   OBTER_DESCRICAO_DETALHES,
   OBTER_GRUPO_USUARIO,
   OBTER_OCORRENCIA
} from './mutations-types'

export const ActionObterGruposUsuario = async ({ commit }, filtros) =>
   await ApiObterGrupoUsuario(filtros)
      .then((response) => commit(OBTER_GRUPO_USUARIO, response))
      .catch(() => commit(OBTER_GRUPO_USUARIO, null))

export const ActionObterJustificativa = async ({ commit }, filtros) =>
   await ApiObterJustificativa(filtros)
      .then((response) => commit(OBTER_DESCRICAO, response))
      .catch(() => commit(OBTER_DESCRICAO, null))

export const ActionObterDetalhesJustificativa = async ({ commit }, id) => {
   await ApiObterDetalhesJustificativa(id)
      .then((response) => {
         commit(OBTER_DESCRICAO_DETALHES, response)
      })
      .catch(() => commit(OBTER_DESCRICAO_DETALHES, null))
}

export const ActionObterOcorrencia = async ({ commit }) =>
   await ApiObterOcorrenciaTipo()
      .then((response) => commit(OBTER_OCORRENCIA, response))
      .catch(() => commit(OBTER_OCORRENCIA, null))

export const ActionRegistrarJustificativa = async ({ commit }, payload) =>
   await ApiRegistrarJustificativa(payload)
      .then((response) => commit(INCLUIR_JUSTIFICATIVA, response))
      .catch(() => commit(INCLUIR_JUSTIFICATIVA, null))

export const ActionSetIncluirJustificativa = async ({ commit }, payload) => commit(INCLUIR_JUSTIFICATIVA, payload)

export const ActionDoEditarJustificativa = async ({ commit }, { id, payload }) =>
   await ApiEditarJustificativa(id, payload).then((response) => commit(EDITAR_JUSTIFICATIVA, response))
